/* cspell:ignore WEBVTT */
import { createSubtitleTrackUrl } from "../../components/subtitle-track";

/**
 * Cues from the explainer's narration, split at phrase boundaries. `line:-2`
 * keeps each cue one line clear of the bottom edge instead of letting the
 * browser drop it to the edge once the controls fade; the surrounding spaces
 * give the cue box side padding, which browsers do not let CSS add.
 */
const CREDIT_INCENTIVE_EXPLAINER_VTT = `WEBVTT

1
00:00.100 --> 00:04.540 line:-2
&nbsp;Brands using Credit Incentive are growing total sales by 5.5%,&nbsp;

2
00:05.360 --> 00:08.240 line:-2
&nbsp;not from ads, from customers they already have.&nbsp;

3
00:09.500 --> 00:11.300 line:-2
&nbsp;When a customer adds coverage at checkout,&nbsp;

4
00:11.580 --> 00:13.580 line:-2
&nbsp;they earn store credit for their next order.&nbsp;

5
00:14.860 --> 00:16.940 line:-2
&nbsp;You set the amount and how long it lasts.&nbsp;

6
00:17.580 --> 00:19.580 line:-2
&nbsp;The credit lands in their account automatically.&nbsp;

7
00:20.460 --> 00:21.740 line:-2
&nbsp;Two days before it expires,&nbsp;

8
00:22.220 --> 00:24.140 line:-2
&nbsp;they get a reminder email from your brand.&nbsp;

9
00:25.080 --> 00:26.060 line:-2
&nbsp;It's free to turn on.&nbsp;

10
00:26.840 --> 00:28.980 line:-2
&nbsp;Every dollar of credit your customers spend&nbsp;

11
00:29.200 --> 00:31.580 line:-2
&nbsp;brings back 13 dollars in sales,&nbsp;

12
00:32.400 --> 00:35.580 line:-2
&nbsp;and those carts are 20% bigger than your average order.&nbsp;

13
00:36.920 --> 00:38.140 line:-2
&nbsp;Coverage protects the order.&nbsp;

14
00:38.780 --> 00:41.140 line:-2
&nbsp;Credit Incentive brings the customer back.&nbsp;

15
00:42.180 --> 00:45.080 line:-2
&nbsp;Book a meeting and get set up in less than 15 minutes.&nbsp;
`;

export function getCreditIncentiveSubtitleUrl(): string {
  return createSubtitleTrackUrl(CREDIT_INCENTIVE_EXPLAINER_VTT);
}
